import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { obtenerChats } from "../api";
import { formatearTiempoTranscurrido } from "../utils/formatFecha";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Chats = () => {
  const { user, authReady } = useAuth();
  const navigate = useNavigate();
  const [chats, setChats] = useState([]);
  const [loadingChats, setLoadingChats] = useState(true);
  const showSplash = useDynamicSplash(loadingChats);

  useEffect(() => {
    if (!authReady) return;

    if (!user?.id) {
      navigate("/login");
      return;
    }

    window.history.replaceState({}, "", "/perfil");
    window.history.pushState({}, "", "/chats");

    document.body.style.overflow = "hidden";

    const cargarChats = async () => {
      try {
        setLoadingChats(true);
        const data = await obtenerChats(user.id);
        setChats(data || []);
      } catch (err) {
      } finally {
        setLoadingChats(false);
        document.body.style.overflow = "auto";
        window.scrollTo(0, 0);
      }
    };

    cargarChats();
  }, [authReady, user]);

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}

      {!showSplash && (
        <motion.div
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
        >
          <div className="app-container">
            <div className="connections-container">
              <div className="back-container">
                <button className="back-btn" onClick={() => navigate("/perfil", { replace: true })}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="48"
                      d="M244 400L100 256l144-144M120 256h292"
                    />
                  </svg>
                </button>
              </div>
              <h2 className="connections-title">Mis conexiones</h2>
              <div className="connections-list">
                {chats.map((chat) => (
                  <div
                    key={chat.id_comercio}
                    className="connection-item"
                    onClick={() =>
                      navigate(`/chat/${chat.id_comercio}/${chat.id_sucursal}`, {
                        state: { from: "chats" },
                      })
                    }
                  >
                    <img
                      src={chat.logo || "/assets/images/default.png"}
                      alt={chat.nombre}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/assets/images/default.png";
                      }}
                    />
                    <div className="connection-info">
                      <span className="business-name">
                        {chat.nombre}
                        <span className="verifieds">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
                            <path
                              fill="currentColor"
                              d="M10.95 12.7L9.5 11.275Q9.225 11 8.813 11t-.713.3q-.275.275-.275.7t.275.7l2.15 2.15q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.287-.7t-.287-.7q-.3-.3-.712-.312t-.713.287zm-2.8 9.05L6.7 19.3l-2.75-.6q-.375-.075-.6-.387t-.175-.688L3.45 14.8l-1.875-2.15q-.25-.275-.25-.65t.25-.65L3.45 9.2l-.275-2.825q-.05-.375.175-.688t.6-.387l2.75-.6l1.45-2.45q.2-.325.55-.438t.7.038l2.6 1.1l2.6-1.1q.35-.15.7-.038t.55.438L17.3 4.7l2.75.6q.375.075.6.388t.175.687L20.55 9.2l1.875 2.15q.25.275.25.65t-.25.65L20.55 14.8l.275 2.825q.05.375-.175.688t-.6.387l-2.75.6l-1.45 2.45q-.2.325-.55.438t-.7-.038l-2.6-1.1l-2.6 1.1q-.35.15-.7.038t-.55-.438"
                            />
                          </svg>
                        </span>
                      </span>
                      <p className="connection-message">{chat.texto}</p>
                    </div>
                    <span className="time">
                      {formatearTiempoTranscurrido(chat.ultima_fecha)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Chats;
